import React from 'react'

import UserDropdown from './UserDropdown'

import useUserProfile from 'modules/user/useUserProfile'

const UserNavbarSection: React.FC = () => {
  const { data } = useUserProfile(true)
  const unreadNotifications = data?.me?.notifications?.meta.totalCount

  return (
    <UserDropdown user={data?.me} unreadNotifications={unreadNotifications} />
  )
}

export default UserNavbarSection
